// extracted by mini-css-extract-plugin
export default {"maincontainer":"MainContainer_maincontainer__jCacR","left":"MainContainer_left__OWzOz","right":"MainContainer_right__JmXjB"};